import { combineReducers } from 'redux';
import adminTrustProfilesReducer from './adminTrustProfilesReducer';
import adminTrustProfileReducer from './adminTrustProfileReducer';

export default combineReducers({
  trustProfile: adminTrustProfileReducer,
  trustProfiles: adminTrustProfilesReducer,
});
